import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';

import AuthArtistCodeVerification from './components/AuthArtistCodeVerification';
import AuthArtistCreateAccount from './components/AuthArtistCreateAccount';
import AuthArtistSignupForm from './components/AuthArtistSignupForm';

import './index.css';

export default function AuthArtistSignup({ setCurrentPage }) {
  const location = useLocation();
  const [isArtistVerified, setIsArtistVerified] = useState(false);
  const [oobCode, setOobCode] = useState(null);
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const prefillEmail = params.get("claim_email") || params.get("email");

    if (!prefillEmail) {
      return;
    }

    setUserEmail((prev) => {
      if (prev) {
        return prev;
      }
      return prefillEmail.trim();
    });
  }, [location.search]);

  const onGoBackClick = () => {
    setCurrentPage("sign-up");
  };

  return (
    <>
      <div className="artist-sign-up_go-back-container">
        <BackArrowIcon onClick={onGoBackClick} className='artist-go-back__button'/>
        <p className='artist-sign-up_breadcrumb'>Claim Artist Profile</p>
      </div>
        
      <AuthArtistSignupForm 
        oobCode={oobCode} 
        setOobCode={setOobCode}
        userEmail={userEmail}
        setUserMail={setUserEmail}
      />

      {oobCode && (
        <AuthArtistCodeVerification 
          oobCode={oobCode} 
          setIsArtistVerified={setIsArtistVerified} 
          setCurrentPage={setCurrentPage}
          userEmail={userEmail}
          isArtistVerified={isArtistVerified}
        />
      )}

      {isArtistVerified && <AuthArtistCreateAccount 
        oobCode={oobCode} 
      />}
    </>
  );
  
}
